export default function ReservationIcon() {
  return (
    <svg width="68" height="58" viewBox="0 0 68 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="50.9493"
        height="29.6559"
        rx="4"
        transform="matrix(0.970097 -0.242723 0.246116 0.969242 0 18.2578)"
        fill="#101313"
      />
      <rect
        width="50.9493"
        height="29.6559"
        rx="4"
        transform="matrix(0.970097 -0.242723 0.246116 0.969242 0 18.2578)"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        width="50.9493"
        height="29.6559"
        rx="4"
        transform="matrix(0.970097 -0.242723 0.246116 0.969242 0 18.2578)"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <line
        y1="-0.75"
        x2="29.6129"
        y2="-0.75"
        transform="matrix(0.245546 0.969385 -0.969954 0.243287 37.0898 8.99219)"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeDasharray="3 3"
      />
      <line
        y1="-0.75"
        x2="29.6129"
        y2="-0.75"
        transform="matrix(0.245546 0.969385 -0.969954 0.243287 37.0898 8.99219)"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeDasharray="3 3"
      />
      <rect x="13.8125" y="23.8672" width="51" height="29.6042" rx="4" fill="#101313" />
      <rect
        x="13.8125"
        y="23.8672"
        width="51"
        height="29.6042"
        rx="4"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        x="13.8125"
        y="23.8672"
        width="51"
        height="29.6042"
        rx="4"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <line
        x1="52.8125"
        y1="23.8672"
        x2="52.8125"
        y2="53.4714"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeDasharray="3 3"
      />
      <line
        x1="52.8125"
        y1="23.8672"
        x2="52.8125"
        y2="53.4714"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeDasharray="3 3"
      />
      <path
        d="M31.3438 32.3281L33.2273 36.6207L37.912 37.0768L34.3914 40.1859L35.4031 44.7604L31.3438 42.3893L27.2844 44.7604L28.2961 40.1859L24.7755 37.0768L29.4602 36.6207L31.3438 32.3281Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M31.3438 32.3281L33.2273 36.6207L37.912 37.0768L34.3914 40.1859L35.4031 44.7604L31.3438 42.3893L27.2844 44.7604L28.2961 40.1859L24.7755 37.0768L29.4602 36.6207L31.3438 32.3281Z"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
